
export enum ProposalStatus {
    open = 'open',
    saved = 'saved',
    complete = 'complete',
    finalized = 'finalized'
}

/**
 * PROPOSAL
 */
const proposalFields = {
    id: { required: true },
    merchantId: { required: true },
    createdAt: { required: true },
    updatedAt: { required: true },
    status: { required: true },
    showMerchant: { required: true },
    shareToken: { required: false },
    showComparisonSummaryTab: { required: false },
    summaryCalculationMode: { required: false },
    summaryMonthYear: { required: false },
    summaryNotes: { required: false },
};

export enum SummaryCalculationMode {
    average = 'average',
    median = 'median'
}

export class Proposal {
    constructor(proposal: Partial<Proposal>) {
        Object.assign(this, proposal);
        for (const key in proposalFields)
            if (this[key as keyof Proposal] == null && (proposalFields as Record<string, { required: boolean }>)[key].required)
                throw Error(`${key} cannot be null`);
    }

    id: string | null = null;
    merchantId: string | null = null;

    createdAt: Date | null = null;
    updatedAt: Date | null = null;
    status: ProposalStatus | null = null;

    showMerchant: boolean | null = null;
    showComparisonSummaryTab: boolean | null = null;
    summaryCalculationMode: SummaryCalculationMode | null = null;
    summaryMonthYear: Array<{ month: string; year: string }> | null = null;
    summaryNotes: string | null = null;
    createdBy: string | null = null;
    shareToken: string | null = null;

}

export class ProposalListItem {
    id: string | null = null;
    createdAt: Date | null = null;
    status: ProposalStatus | null = null;
    merchantName: string | null = null;
    merchantId: string | null = null;
    groupId?: string | null = null;
    teamId?: string;
    createdBy?: string;
}

